<template lang="pug">
div
    Modal(:title="title", v-model="isModalShow", width="800")
        Table(:columns="talbleColumns", :data="objectLogResult")
        div(slot="footer")
            Button(type="primary", @click="isModalShow = false") {{ $t('global.close') }}
    Button(@click="getObjectLog", size="small") view changes
</template>
<script>
import { _getObjectLog } from "@/api/rest/index.js";
import { _dateFormat } from "@/libs/dateformat.js";

export default {
    name: "ObjectLogBtn",
    props: ["title", "objId", "groupName"],
    components: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    data() {
        return {
            isModalShow: false,
            talbleColumns: [
                {
                    title: "User",
                    // width: "100px",
                    key: "username",
                    render: (h, params) => {
                        return h("div", {}, params.row.username);
                    },
                },
                {
                    title: "Submit",
                    key: "submitTime",
                    width: "200px",
                    render: (h, params) => {
                        return h("div", _dateFormat(params.row.submitTime, "YYYY-MM-DD HH:mm:ss"));
                    },
                },
                {
                    title: "Action",
                    key: "actionName",
                    render: (h, params) => {
                        return h("div", {}, params.row.actionName);
                    },
                },
                {
                    title: "Content",
                    key: "diffData",
                    sortable: false,
                    render: (h, params) => {
                        return h("JsonPoptip", {
                            props: {
                                jsonData: params.row.diffData,
                                title: this.$t("tasks.diffData"),
                                buttonText: this.$store.getters.getJsonPopTipConfig.withIcon ? "" : "顯示",
                                buttonIcon: this.$store.getters.getJsonPopTipConfig.withIcon ? "md-eye" : "",
                            },
                        });
                    },
                },
            ],
            objectLogResult: [],
        };
    },
    methods: {
        getObjectLog() {
            _getObjectLog(this.objId, this.groupName)
                .then((result) => {
                    // console.log(result);
                    this.objectLogResult = result.data.data;
                    this.isModalShow = true;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
    mounted() {},
    computed: {},
};
</script>



// WEBPACK FOOTER //
// src/components/ObjectLogBtn.vue